import { Component } from '@angular/core'
import { CartTotalsComponent } from '@spartacus/cart/base/components'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { Observable } from 'rxjs'
import { EbBaseSiteService } from '../../../site-context/services/eb-base-site.service'
import { EbCart } from '../../interface/eb-cart.interface'
import { EbOrderEntry } from '../../interface/eb-order-entry.interface'

@Component({
    selector: 'eb-cart-totals',
    templateUrl: './eb-cart-totals.component.html',
    styleUrls: ['./eb-cart-totals.component.scss'],
    standalone: false
})
export class EbCartTotalsComponent extends CartTotalsComponent {
  cart$: Observable<EbCart>
  entries$: Observable<EbOrderEntry[]>
  constructor(
    protected activeCartService: ActiveCartFacade,
    protected baseSiteService: EbBaseSiteService
  ) {
    super(activeCartService)
  }

  ngOnInit() {
    super.ngOnInit()
    this.entries$ = this.activeCartService.getEntries()
  }
}
